<template>
  <img v-if="src" :src="src" :alt="alt" />
</template>

<script>
import { fetchImage } from "@/entities/face-recognition";

export default {
  name: "AuthorizedImage",
  props: {
    objectName: { type: String, required: true },
    alt: { type: String, default: "" },
  },

  emits: ["loaded", "load-failed"],

  data() {
    return {
      src: "",
      fetchToken: 0,
    };
  },

  watch: {
    objectName: {
      immediate: true,
      async handler(value) {
        this.src = "";
        if (!value) {
          this.$emit("load-failed", value || "");
          return;
        }
        const token = ++this.fetchToken;
        try {
          const res = await fetchImage(value);
          if (token !== this.fetchToken) return;
          if (res?.status && res?.data) {
            const type = res.content_type || "image/jpeg";
            this.src = `data:${type};base64,${res.data}`;
            this.$emit("loaded", value);
          } else {
            this.$emit("load-failed", value);
          }
        } catch {
          if (token === this.fetchToken) {
            this.src = "";
            this.$emit("load-failed", value);
          }
        }
      },
    },
  },
};
</script>
